const AboutContact = ({ data }) => (
  <section className="py-28 bg-[#0a363c] text-white">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <h2 className="text-4xl font-bold mb-6">{data.title}</h2>
      <p className="text-lg mb-8 text-gray-100 leading-relaxed">
        {data.description}
      </p>
      <a
        href={`mailto:${data.email}`}
        className="inline-block bg-[#e2bf9c] text-[#0a363c] px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#d4aa7e] transition"
      >
        {data.email}
      </a>
    </div>
  </section>
);

export default AboutContact;
